import type { TranslationTag } from '@ps/web-core-intl';
import { select } from '@ps/web-core-store';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export interface GetOverrideTranslationProps {
  vegas: string | undefined;
  isSiteDE: boolean;
  ontario: string | undefined;
  showOntarioContent: boolean;
}

export const getOverrideTranslation = ({
  vegas,
  isSiteDE,
  ontario,
  showOntarioContent
}: GetOverrideTranslationProps) => {
  if (vegas && isSiteDE) {
    return { defaultMessage: vegas };
  }

  if (ontario && showOntarioContent) {
    return { defaultMessage: ontario };
  }

  return {};
};

export const useRegulatoryOverride = ({ vegas, ontario }: TranslationTag) => {
  const isSiteDE = useSelector(select.cms.isSiteDE);
  const showOntarioContent = useSelector(select.cms.showOntarioContent);

  return useMemo(
    () => getOverrideTranslation({ vegas, ontario, isSiteDE, showOntarioContent }),
    [isSiteDE, vegas, showOntarioContent, ontario]
  );
};
